import { Card, Paper } from "@material-ui/core";
import styled from "styled-components";

export const FieldWrapper = styled.div<{ withPaddingTop?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  padding: ${({ withPaddingTop }) =>
    withPaddingTop ? "24px 30px 24px 24px" : "0px 30px 24px 24px"};
  label {
    align-self: baseline;
  }
`;

export const DisabledContainer = styled(Paper)`
  padding: 35px 25px;
  display: flex;
  gap: 25px;
  align-items: center;
  svg {
    font-size: 5.2rem;
    color: rgba(0, 0, 0, 0.12);
    margin-bottom: 15px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  button {
    align-self: flex-start;
  }
`;

export const StyledCard = styled(Card)`
  border-radius: 8px;
  .MuiCardHeader-action {
    align-self: center;
    margin: 0;
  }
  .MuiCardHeader-avatar {
    color: rgba(0, 0, 0, 0.54);
  }
  .MuiCardHeader-title {
    font-weight: 500;
  }
`;

export const LevelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`;
